import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { GalaxySnackbarModule, SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { AsyncUiModule } from '@vendasta/uikit';
import baseTranslation from '../../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../constants';
import { DomainRecordsTableModule } from '../shared/domain-records-table/domain-records-table.module';
import { DomainRecordsModule } from '../shared/domain-records.module';
import { MismatchToRowPipe, PendingDomainComponent } from './pending-domain.component';
import { PendingDomainService } from './pending-domain.service';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    GalaxyInputModule,
    GalaxyAlertModule,
    GalaxyEmptyStateModule,
    GalaxySnackbarModule,
    DomainRecordsModule,
    DomainRecordsTableModule,
    AsyncUiModule,
    MatButtonModule,
  ],
  exports: [PendingDomainComponent],
  declarations: [MismatchToRowPipe, PendingDomainComponent],
  providers: [PendingDomainService, SnackbarService],
})
export class PendingDomainModule {}
